"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _config = require("../utils/config");

var _constants = require("../constants");

// 页面加载时间
var _default = function _default() {
  var performance = window.performance;

  if (performance) {
    var _getConfig = (0, _config.getConfig)(),
        pageDidMountTime = _getConfig.pageDidMountTime;

    var _performance$timing = performance.timing,
        navigationStart = _performance$timing.navigationStart,
        domainLookupStart = _performance$timing.domainLookupStart,
        domainLookupEnd = _performance$timing.domainLookupEnd,
        connectStart = _performance$timing.connectStart,
        connectEnd = _performance$timing.connectEnd,
        requestStart = _performance$timing.requestStart,
        responseEnd = _performance$timing.responseEnd,
        loadEventEnd = _performance$timing.loadEventEnd,
        domContentLoadedEventEnd = _performance$timing.domContentLoadedEventEnd; // DOMContentLoaded
    // https://www.cnblogs.com/Bonnie3449/p/8419609.html

    return {
      data: {
        ua: window.navigator.userAgent,
        // DNS查询耗时
        DNSLookupTime: domainLookupEnd - domainLookupStart,
        // TCP连接耗时
        TCPConnectTime: connectEnd - connectStart,
        // 请求完成耗时
        requestCompleteTime: responseEnd - requestStart,
        // 白屏时间 也是可交互时间
        whiteScreenTime: (pageDidMountTime || domContentLoadedEventEnd) - navigationStart,
        // 总下载时间
        allLoadTime: loadEventEnd - navigationStart
      },
      name: _constants.METRIC_PAGE_TIME,
      type: _constants.METRIC_COUNTER_TYPE
    };
  }

  return null;
};

exports.default = _default;